import React from 'react';

import CoachConfigurations from '../CoachConfigurations';
import {
  tabs,
  tabsConfig,
} from './utils';

const CRXCoachConfigurations = () => (
  <CoachConfigurations
    defaultTab={tabs.MOBILE_APP}
    tabsConfig={tabsConfig}
  />
);

export default CRXCoachConfigurations;
